<template>
  <div class="addPackageWrapper">
    <q-linear-progress v-if="this.isFetching" indeterminate />
    <q-form @submit="onSubmit" class="form">
      <div class="form__item">
        <div class="sbs-project-selector">
          <CustomInput label="ЖК (проект SBS)" :value="formData.naimenovanie || 'Не выбран'" :disabled="true"
            style="flex: 1;" :required="true" />
          <q-btn label="Выбрать" color="primary" @click="openSbsProjectModal" style="margin-top: 22px; height: 46px;" />
        </div>
      </div>

      <div class="form__item">
        <CustomSelect :options="externalResourceOptions" label="Тип проекта" option-label-key="label"
          option-value-key="value" @change="value => onChange('external_resource_code', value)"
          :value="formData.external_resource_code" :required="true" style="width: 100%;" />
      </div>

      <div class="form__item">
        <custom-date label="Дата начала" placeholder="Дата начала" :value="formData.start_date || ''"
          @change_date="(value) => onChange('start_date', value)" :required="true" style="width: 100%;" />
        <custom-date label="Дата окончания" placeholder="Дата окончания" :value="formData.finish_date || ''"
          @change_date="(value) => onChange('finish_date', value)" :required="true" style="width: 100%;" />
      </div>

      <div class="form__item">
        <CustomInput label="Аванс" :value="formData.avans" allow-negative="false" type="number"
          @change_input="(value) => onChange('avans', value)" style="width: 100%;" />
      </div>

      <CustomModalFooter :btn-loading="loading" submit-btn-text="Создать" />
    </q-form>

    <!-- Модалка выбора проекта SBS -->
    <q-dialog v-model="sbsProjectDialog" persistent maximized>
      <q-card
        style="width: 100vw; height: 100vh; display: flex; flex-direction: column; max-width: 100vw; max-height: 100vh;">
        <q-card-section class="row items-center q-pb-none" style="flex-shrink: 0;">
          <div style="display: flex; align-items: center; gap: 20px; flex: 1;">
            <div class="text-h6" style="margin: 0;">Выбор проекта УСП BI GROUP</div>
            <div v-if="data?.body?.resident_name || data?.body?.project_type_name"
              style="display: flex; gap: 15px; padding: 8px 16px; background-color: #e3f2fd; border-radius: 6px; border-left: 4px solid #2196f3;">
              <div v-if="data?.body?.resident_name" style="font-size: 14px; color: #1565c0;">
                <span style="font-weight: 600;">ЖК:</span> <span style="font-weight: 500;">{{ data.body.resident_name
                }}</span>
              </div>
              <div v-if="data?.body?.project_type_name" style="font-size: 14px; color: #1565c0;">
                <span style="font-weight: 600;">Тип проекта:</span> <span style="font-weight: 500;">{{
                  data.body.project_type_name }}</span>
              </div>
            </div>
          </div>
          <q-btn icon="close" flat round dense @click="sbsProjectDialog = false" />
        </q-card-section>

        <q-card-section style="flex: 1; overflow: hidden; display: flex; flex-direction: column; padding: 20px;">
          <div style="display: flex; gap: 15px; align-items: center; margin-bottom: 15px;">
            <q-input v-model="searchText" outlined dense placeholder="Поиск по названию проекта, ID или родителю..."
              clearable style="flex: 1;">
              <template v-slot:prepend>
                <q-icon name="search" />
              </template>
            </q-input>
            <div
              style="display: flex; align-items: center; gap: 10px; padding: 8px 16px; background-color: #f5f5f5; border-radius: 6px; white-space: nowrap;">
              <q-icon name="list" size="20px" color="primary" />
              <span style="font-size: 14px; font-weight: 600; color: #333;">
                Найдено: {{ filteredSbsProjects.length }} из {{ allSbsProjects.length }}
              </span>
            </div>
          </div>

          <div v-if="loadingSbsProjects"
            style="display: flex; flex-direction: column; align-items: center; justify-content: center; flex: 1; padding: 60px 20px;">
            <q-spinner color="primary" size="60px" />
            <div style="margin-top: 20px; font-size: 16px; color: #666; font-weight: 500;">
              Загрузка проектов УСП...
            </div>
            <div style="margin-top: 8px; font-size: 13px; color: #999;">
              Пожалуйста, подождите
            </div>
          </div>

          <div v-else-if="filteredSbsProjects.length === 0"
            style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 60px 20px; color: #999;">
            <q-icon name="search_off" size="64px" color="grey-5" />
            <div style="margin-top: 16px; font-size: 16px; color: #666;">Проекты не найдены</div>
          </div>

          <q-table v-else :rows="filteredSbsProjects" :columns="sbsProjectColumns" row-key="sbs_project_id" flat
            bordered :rows-per-page-options="[20, 50, 100, 500, 0]" :pagination="{ rowsPerPage: 0 }"
            style="flex: 1; height: 100%;" virtual-scroll :virtual-scroll-item-size="48"
            :virtual-scroll-sticky-size-start="48">
            <template v-slot:body-cell-actions="props">
              <q-td :props="props">
                <q-btn label="Выбрать" color="primary" size="sm" unelevated @click="selectSbsProject(props.row)" />
              </q-td>
            </template>
          </q-table>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import CustomDate from "@/components/form/CustomDate";
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { getProjectTypes } from "@/views/BuildingSettings/services";
import { getSbsProjectListSimple } from "@/views/sbsProject/services";

export default {
  name: "add-project-entry",
  components: { CustomInput, CustomSelect, CustomModalFooter, CustomDate },
  props: ["data"],
  data() {
    return {
      loading: false,
      isFetching: false,
      residencyOptions: [],
      typeOptions: [],
      sbsProjectDialog: false,
      searchText: "",
      searchDebounceTimer: null,
      debouncedSearchText: "",
      loadingSbsProjects: false,
      allSbsProjects: [],
      sbsProjectColumns: [
        {
          name: 'sbs_project_id',
          label: 'ID',
          field: 'sbs_project_id',
          align: 'left',
          sortable: true,
        },
        {
          name: 'naimenovanie',
          label: 'Название проекта',
          field: 'naimenovanie',
          align: 'left',
          sortable: true,
        },
        {
          name: 'roditel__view',
          label: 'Родитель',
          field: 'roditel__view',
          align: 'left',
          sortable: true,
        },
        {
          name: 'actions',
          label: 'Действия',
          field: 'actions',
          align: 'center',
          style: 'width: 150px;'
        }
      ],
      formData: {
        project_id: this.data?.body?.project_id || "",
        project_name: this.data?.body?.project_name || "",
        project_short_name: this.data?.body?.project_short_name || "",
        project_type_id: this.data?.body?.project_type_id || "",
        start_date: this.data?.body?.start_date || "",
        finish_date: this.data?.body?.finish_date || "",
        placement_type_id: this.data?.body?.placement_type_id || "",
        project_entrance_id: this.data?.body?.entrances || [],
        entrances_info: this.data?.body?.entrances_info || [],
        sbs_project_id: this.data?.body?.sbs_project_id || "",
        naimenovanie: this.data?.body?.naimenovanie || "",
        entrances: this.data?.body?.entrances || [],
        resident_id: this.data?.body?.resident_id || "",
        external_resource_code: this.data?.body?.external_resource_code || "AUTOCAD",
        avans: this.data?.body?.avans || 0,
      },
      externalResourceOptions: [
        { label: 'AUTOCAD', value: 'AUTOCAD' },
        { label: 'REVIT', value: 'REVIT' }
      ],
    };
  },
  computed: {
    filteredSbsProjects() {
      if (!this.debouncedSearchText) {
        return this.allSbsProjects;
      }

      const query = this.debouncedSearchText.toLowerCase();
      return this.allSbsProjects.filter(project => {
        return (
          project.naimenovanie?.toLowerCase().includes(query) ||
          project.sbs_project_id?.toString().includes(query) ||
          project.roditel__view?.toLowerCase().includes(query)
        );
      });
    },
  },
  watch: {
    searchText(newVal) {
      // Debounce search - ждем 300ms после последнего ввода
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }
      this.searchDebounceTimer = setTimeout(() => {
        this.debouncedSearchText = newVal;
      }, 300);
    },
    sbsProjectDialog(newVal) {
      // Очищаем поиск при закрытии модалки
      if (!newVal) {
        this.searchText = "";
        this.debouncedSearchText = "";
      }
    },
  },
  async mounted() {
    this.isFetching = true;
    await this.getProjectTypes();

    // Загружаем название проекта, если есть sbs_project_id
    if (this.formData.sbs_project_id && !this.formData.naimenovanie) {
      await this.loadProjectName();
    }

    this.isFetching = false;
  },

  methods: {
    async loadProjectName() {
      try {
        const projects = await getSbsProjectListSimple();
        const project = projects.find(p => p.sbs_project_id === this.formData.sbs_project_id);
        if (project) {
          this.formData.naimenovanie = project.naimenovanie;
        }
      } catch (error) {
        console.error('Error loading project name:', error);
      }
    },
    async openSbsProjectModal() {
      this.sbsProjectDialog = true;
      await this.loadSbsProjects();
    },
    async loadSbsProjects() {
      this.loadingSbsProjects = true;
      try {
        const res = await getSbsProjectListSimple();
        this.allSbsProjects = res || [];
      } catch (error) {
        console.error('Error loading SBS projects:', error);
      }
      this.loadingSbsProjects = false;
    },
    selectSbsProject(project) {
      this.formData.sbs_project_id = project.sbs_project_id;
      this.formData.naimenovanie = project.naimenovanie;
      this.sbsProjectDialog = false;
    },
    async getProjectTypes() {
      const res = await getProjectTypes();
      this.typeOptions = res || [];
    },
    async onChange(key, value) {
      this.formData[key] = value;
    },
    async onSubmit() {
      this.loading = true;
      const filteredFormData = {
        project_id: this.formData.project_id,
        project_name: this.formData.project_name,
        project_short_name: this.formData.project_short_name,
        resident_id: this.formData.resident_id,
        project_type_id: this.formData.project_type_id,
        start_date: this.formData.start_date,
        finish_date: this.formData.finish_date,
        sbs_project_id: this.formData.sbs_project_id,
        external_resource_code: this.formData.external_resource_code,
        avans: parseFloat(this.formData.avans),
      };
      await this.data?.onSubmit(filteredFormData);
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.addPackageWrapper {
  max-width: 700px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
}

.form {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 15px;
  margin-top: 15px;

  &__item {
    width: 100%;
    display: flex;
    gap: 16px;

    :deep(.custom-date) {
      width: 100%;
      max-width: 100%;
    }
  }

  @media (max-width: 428px) {
    min-width: 100%;
  }
}

.sbs-project-selector {
  display: flex;
  gap: 10px;
  width: 100%;
  align-items: flex-start;
}
</style>
